var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16659 18.3333C3.70635 18.3333 3.33325 17.9602 3.33325 17.5V2.5C3.33325 2.03977 3.70635 1.66667 4.16659 1.66667H15.8333C16.2935 1.66667 16.6666 2.03977 16.6666 2.5V5H14.9999V3.33333H4.99992V16.6667H14.9999V15H16.6666V17.5C16.6666 17.9602 16.2935 18.3333 15.8333 18.3333H4.16659ZM14.9999 13.3333V10.8333H9.16658V9.16667H14.9999V6.66667L19.1666 10L14.9999 13.3333Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b7b9ea23717670ab19223214d3c85214.svg";
export { ForwardRef as ReactComponent };